// extracted by mini-css-extract-plugin
module.exports = {"green":"RelativeAvailabilityTimespan_green__FBS5O","blue":"RelativeAvailabilityTimespan_blue__DuDCy"};